<template>
  <div>
    <Top />
    <News /> 
  </div>
</template>

<script>
    import Top from '@/components/Top'
    import News from '@/views/News'

    export default {
      name: 'Home',
      components: {
          Top, News
        }
      }
</script>
